//import liraries
import React  from 'react';
import { View, Text,  ActivityIndicator } from 'react-native';
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize } from "rn-responsive-styles";

// create a component
const Loader = (props) => {
    const styles = useStyles();
   
    return (
        <View style={styles.container}>
            <View style={styles.loaderBg}>
                <ActivityIndicator size={props.size ? props.size : "large"} color="#707070" style={styles.spinner} />
                <Text  style={styles.textStyle} > {"Please wait..."} </Text>
                <Text  style={styles.subTextStyle} >  {"while we fetch your details"} </Text>
            </View>
        </View>
    );
};

// define your styles
const useStyles = CreateResponsiveStyle({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0,0,0,0.5)',
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: 9999
    },
    textStyle:{
        fontFamily: "Inter",
        fontSize: 13,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 15,
        letterSpacing: 0,
        textAlign: "center",
        color: "#02122c",
        paddingTop:15
    },
    subTextStyle:{
        opacity: 0.6,
        fontFamily: "Inter",
        fontSize: 13,
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 15,
        letterSpacing: 0,
        textAlign: "center",
         color: "#02122c",
         paddingTop:15
    },
    spinner: {
        marginTop: -20,
        transform: [
            { scaleX: 1 },
            { scaleY: 1 },
        ],
    },
    loaderBg:{
        width: 323,
        height: 192,
        borderRadius: 13,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.05)",
        shadowOffset: {
            width: 0,
            height: 27
        },
        shadowRadius: 34,
        shadowOpacity: 1,
        alignItems: "center",
        justifyContent: "center"
    }
},{
    [maxSize(DEVICE_SIZES.XS)]: {
      loaderBg: {
        width: "90%",
      },
 
    },
  });

//make this component available to the app
export default Loader;
